var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHouseLaptop = function SvgHouseLaptop(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M7.14 3.232a.92.92 0 0 1 1.22 0l5.85 5.25c.189.17.29.405.29.643h-4.05c-.537 0-1.02.23-1.35.593v-1.03a.445.445 0 0 0-.45-.438h-1.8a.445.445 0 0 0-.45.437v1.75c0 .24.203.438.45.438h1.8v3.5h-4.5c-.745 0-1.35-.588-1.35-1.313V10h-.9a.9.9 0 0 1-.838-.555.86.86 0 0 1 .228-.963zm3.76 8.08v3.938h5.4v-3.938zm-1.35-.437c0-.484.402-.875.9-.875h6.3c.498 0 .9.39.9.875v4.375h.9c.247 0 .45.197.45.437 0 .725-.605 1.313-1.35 1.313h-8.1c-.745 0-1.35-.588-1.35-1.313 0-.24.203-.437.45-.437h.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHouseLaptop);
export default ForwardRef;